import React ,{useState , useEffect ,useContext } from 'react'
import { useLocation } from 'react-router-dom';
import "./restaurentInfoComponent.css";
import Rating from "../../../../components/rating/Rating"
import { foodTypes } from '../../../../functions/mini_func'; 
import { RestSkeleton } from '../../../../components/skeletons/skeletons';
import { db } from '../../../../config/firebase_config';
import RestaurentModel from '../../../../models/Restaurent_model';
import { ref ,get} from 'firebase/database';
import RestaurentContext from '../../../../context/rest_context';
import { GoAlert } from 'react-icons/go';

const RestaurentInfoComponent = ({restID}) => {
const [restItem, setRestItem] = useState(null);
const { setTappedStore } = useContext(RestaurentContext);
const location = useLocation();
const queryParams = new URLSearchParams(location.search);
const tableNo = queryParams.get("tableNo");


const isWithinPreOrderTime = () => {
    if (restItem.preOrder) {
      const currentTime = new Date();
      const currentHours = currentTime.getHours();

      const fromHours = restItem.preOrder.from;
      const toHours = restItem.preOrder.to;

      console.log({
        currentHours,
        fromHours,
        toHours
      });

      // Handle case where time range crosses midnight
      if (fromHours > toHours) {
        return currentHours >= fromHours || currentHours <= toHours;
      }

      return currentHours >= fromHours && currentHours <= toHours;
    }
    return false;
};

  useEffect(() => {
    
    const getRestData = async() => {
      
      const dbRestRef = ref(db, `RestaurantMenu/${restID}`);
        const restSnap = await get(dbRestRef);
        if (restSnap.exists()) {
          const data = restSnap.val();
          console.log( "<--- rest comp data  --->" , data , restID);
          const restItem = RestaurentModel.fromJson( restID , data);
          setRestItem(restItem);
          setTappedStore(restItem);
        }
    }

    if(restItem == null){
      getRestData();
    }
  
  }, [])
  

  return (
    restItem == null 
    ?
      (<RestSkeleton />)
    : 
     ( 
     <div>
      <div className='restaurent-items-info-container' >
            <div className='rest-name-rating'>
              <h2>{restItem.name}</h2>
              <div className='handle-rating-position'>
              <Rating rating={restItem.restRating} totalRatings={restItem.totalRating ?? 0  } />
              </div>
            </div>
            <p>{foodTypes(restItem)}</p>
            {tableNo && <p style={{ marginTop: '5px', fontSize: '0.85rem', color: '#f8f8f8', fontWeight: 'bold' }}>Table No: {tableNo}</p>}
        </div>
            {  isWithinPreOrderTime() && 
            <div className='pre-order'>
              <GoAlert style={{fontSize : "2rem"}} />
                Items you order now will be processed as pre-orders for tomorrow.
            </div>
        }

     </div>
     )
   
  )
}

export default RestaurentInfoComponent